/** Explicit care-wizard contexts shared by selection and admission. Unknown
 * query parameters (for example campaign tags) never select a different form. */
export function usesCareIncidentWizard(params: Pick<URLSearchParams, 'get' | 'has'>) {
  return (
    params.get('standard') === '1' ||
    params.get('entry') === 'care-register' ||
    params.has('clientId') ||
    params.has('linkedCocId') ||
    params.has('prefill') ||
    params.get('source') === 'complaint' ||
    params.get('source') === 'ipc_infection'
  );
}
